// ===========================
// 画像アップロード - 複数ファイル対応
export default function initQuformFileUpload() {
    const $ = jQuery;

    let uploadedFilePreviews = {}; // プレビューファイル用オブジェクト

    function updateFileList() {
        const $fileList = $('.quform-element-1_19 .quform-upload-files');
        const $fileNames = $fileList.find('.quform-upload-file-name');

        if ($fileNames.length > 0) {
            let fileListHtml = '';
            $fileNames.each(function () {
                const fileName = $(this).text();
                const preview = uploadedFilePreviews[fileName];

                fileListHtml += '<li>';
                if (preview && preview.isImage) {
                    fileListHtml += '<img src="' + preview.dataUrl + '" style="max-width: 150px; max-height: 150px; display: block; margin: 5px 0;" alt="' + fileName + '">';
                }
                fileListHtml += fileName + '</li>';
            });
            $('#photos-value').html(fileListHtml);
        } else {
            $('#photos-value').text('ファイルが選択されていません');
            uploadedFilePreviews = {};
        }
    }

    // ファイル選択時にプレビューを生成
    function fileUploadDetect() {
        const uploads = document.querySelector('.quform-element-1_19 input[type="file"]');

        console.log('detect:', uploads, uploads.files)
    }

    function handleFileSelect(e) {
        const files = e.target.files;
        console.log('handleFileSelect:', files);

        // 今回選択したファイルを uploadedFilePreviews に追加（上書きではなく追加）
        Array.from(files).forEach((file) => {
            const isImage = file.type.startsWith('image/');

            if (isImage) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    uploadedFilePreviews[file.name] = {
                        isImage: true,
                        dataUrl: e.target.result,
                        fileName: file.name
                    };

                    // プレビュー画像を 該当する.quform-upload-file-name に追加
                    $('.quform-element-1_19 .quform-upload-file-name').each(function () {
                        const $this = $(this);
                        if ($this.text() === file.name && !$this.find('img').length) {
                            const img = `<img src="${e.target.result}" alt="プレビュー" class="c-form__upload-preview-img">`
                            $this.prepend(img);
                        }
                    });
                };
                reader.readAsDataURL(file);
            } else {
                uploadedFilePreviews[file.name] = {
                    isImage: false,
                    fileName: file.name
                };
            }
        });

        // 次のinputにイベントリスナーを設定
        setTimeout(() => {
            uploads = document.querySelector('.quform-element-1_19 input[type="file"]');
            if (uploads) {
                uploads.addEventListener('change', handleFileSelect, { once: true });
            }
        }, 100);
    }

    let uploads = document.querySelector('.quform-element-1_19 input[type="file"]');


    if (uploads) {
        uploads.addEventListener('change', handleFileSelect, { once: true });
    }

    // ファイル削除ボタンのクリック監視
    $(document).on('click', '.quform-upload-file-remove', () => {
        setTimeout(updateFileList, 200);
    });

    // Nextボタン（確認画面へ）クリック時
    $(document).on('click', '.quform-next', () => {
        setTimeout(updateFileList, 100);
    });

    // MutationObserverでファイルリストの変更を監視
    const fileListObserver = new MutationObserver((mutations) => {
        console.log('mutate発生')
        fileUploadDetect();
        updateFileList();
    });

    // 監視対象の要素を取得して監視開始
    const $uploadFiles = $('.quform-element-1_19 .quform-upload-files');
    if ($uploadFiles.length) {
        fileListObserver.observe($uploadFiles[0], {
            childList: true,
            subtree: true
        });
    }

    // 初期表示
    updateFileList()
}